import classNames from '@ui-components-3/ui/lib/utils/classNames'
import ParticipantTile from './ParticipantTile'
import { useActiveSpeakerId, useDaily, useLocalSessionId, useParticipantIds } from '@daily-co/daily-react'
import { useEffect } from 'react'
import Modals from 'singletons/Modals'

type ParticipantsViewProps = {
  compact?: boolean
  onHangup: () => void
}
const ParticipantsView = ({ compact, onHangup }: ParticipantsViewProps) => {
  const callObject = useDaily()
  const localSessionId = useLocalSessionId()
  const otherParticipantsIds = useParticipantIds({ filter: 'remote' })

  const isAlone = !otherParticipantsIds?.length

  const activeSpeakerId = useActiveSpeakerId({ ignoreLocal: true })

  const dominantId = isAlone ? localSessionId : activeSpeakerId || otherParticipantsIds[0]
  const showLocal = !compact || isAlone

  useEffect(() => {
    const onParticipantLeft = () => {
      const { hidden, present } = callObject.participantCounts()
      const totalParticipants = hidden + present

      if (totalParticipants < 2 && !Modals.list.some((m) => m.type === 'confirmEndCall')) {
        onHangup?.()
      }
    }
    callObject?.on('participant-left', onParticipantLeft)

    return () => {
      callObject?.off('participant-left', onParticipantLeft)
    }
  }, [callObject, onHangup])

  if (!localSessionId && isAlone) {
    return null
  }

  return (
    <div
      className={classNames(
        'w-auto h-full overflow-hidden flex items-center justify-center bg-white gap-0.5',
        !compact && 'border-[3px] rounded-lg border-white',
      )}
    >
      {!!showLocal && (
        <ParticipantTile
          sessionId={localSessionId}
          isLocal
          isDominant={localSessionId === dominantId}
          compact={compact}
        />
      )}
      {otherParticipantsIds.map((sessionId) => {
        const isDominant = sessionId === dominantId

        if (!isDominant && compact) {
          return null
        }

        return (
          <ParticipantTile
            key={sessionId}
            sessionId={sessionId}
            isDominant={!compact ? true : isDominant}
            compact={compact}
          />
        )
      })}
    </div>
  )
}

export default ParticipantsView
